import { render, staticRenderFns } from "./scheme.vue?vue&type=template&id=514b0631&scoped=true"
import script from "./scheme.vue?vue&type=script&lang=js"
export * from "./scheme.vue?vue&type=script&lang=js"
import style0 from "./scheme.vue?vue&type=style&index=0&id=514b0631&prod&lang=scss&scoped=true"
import style1 from "./scheme.vue?vue&type=style&index=1&id=514b0631&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514b0631",
  null
  
)

export default component.exports